import { useEffect, useState } from "react";

import { onConnectionStats } from "../broadcast/controlBroadcast";

import type { BroadcastConnectionStats } from "../broadcast/sceneSync";

/** El OSR manda una foto por segundo: sin novedades en este lapso la última se considera vieja. */
export const BROADCAST_STATS_STALE_MS = 6000;

export interface BroadcastStatsState {
  /** Última salud reportada por el OSR; null hasta la primera foto. */
  stats: BroadcastConnectionStats | null;

  /** true si pasaron más de BROADCAST_STATS_STALE_MS sin una foto nueva. */
  stale: boolean;
}

/**
 * Lado control: se suscribe a la salud del broadcast que publica el OSR (BroadcastChannel, vía
 * `onConnectionStats`) y expone la última foto. No deja timers colgados al desmontar.
 */
export function useBroadcastStats(): BroadcastStatsState {
  const [stats, setStats] = useState<BroadcastConnectionStats | null>(null);

  const [stale, setStale] = useState(false);

  useEffect(() => {
    let staleTimer: ReturnType<typeof setTimeout> | null = null;

    const off = onConnectionStats((next) => {
      setStats(next);

      setStale(false);

      if (staleTimer) clearTimeout(staleTimer);

      staleTimer = setTimeout(() => setStale(true), BROADCAST_STATS_STALE_MS);
    });

    return () => {
      off();

      if (staleTimer) clearTimeout(staleTimer);
    };
  }, []);

  return { stats, stale };
}
